<!--
 * @Description: 修改密码
 * @Author: 裴孚
 * @Date: 2023-03-21 18:22:31
 * @LastEditors: Xyyyyyy
 * @LastEditTime: 2023-06-27 12:22:32
-->
<template>
  <div class="tan-chuang">
    <el-dialog class="w410 h360" :model-value="openXgmc" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">修改密码</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openXgmc', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="0">
        <el-row>
          <el-col :span="24">
            <el-form-item prop="ymm" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.ymm" type="password" placeholder="旧密码" show-password>
                <template #prefix>
                  <el-icon>
                    <Lock />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="xmm" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.xmm" type="password" placeholder="新密码" show-password>
                <template #prefix>
                  <el-icon>
                    <Lock />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="xmm" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="qrmm" type="password" placeholder="确认密码" show-password>
                <template #prefix>
                  <el-icon>
                    <Lock />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer-but">
            <el-button type="danger" @click="submit()">保存</el-button>
            <el-button @click="closeWindow('openXgmc', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { postAccessPublickey } from '@/api/access.js'
import { actionPatch, closeWindow } from '@/api/common.js'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import { getRSA } from '@/utils/login.js'

const props = defineProps({ openXgmc: { type: Boolean, required: true } })
const emits = defineEmits(['update:openXgmc', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const qrmm = ref()

// 提交
const submit = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  if (qrmm.value !== ruleForm.value.xmm) {
    return warningPrompt('两次密码不一致，请重新输入')
  }
  postAccessPublickey({}).then((res) => {
    const data = {
      ymm: getRSA(res.message, ruleForm.value.ymm),
      xmm: getRSA(res.message, ruleForm.value.xmm)
    }
    const o = { url: '/api/v2/wangzhanlanmu/yonhu/password', data: data }
    actionPatch(o).then((res) => {
      if (res.code === 200) {
        closeWindow('openXgmc', emits, false)
        successPrompt(res.message)
      } else {
        warningPrompt(res.message)
      }
    })
  })
}
</script>

<style lang="less" scoped>
.el-dialog__header{
  display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 10px 10px 20px;
    .header-left {
      display: flex;
      align-items: center;
      // 图标
      .header-icon {
        font-size: 18px;
        margin-right: 10px;
      }
      // 标题
      .header-title {

        font-size: 16px;
      }
    }
    .header-right {
      margin-left: 234px;
      .e-icon {
        font-size: 18px;
      }
    }
}
</style>
